// TrackOrderSkeleton.jsx
import React from "react";
import "./TrackOrderSkeleton.css";

const TrackOrderSkeleton = () => {
  return (
    <div className="container my-4 my-md-5">
      <h2 className="page-title skeleton-title"></h2>

      <div className="row">
        {[1, 2, 3, 4].map((key) => (
          <div className="col-12 col-lg-6 mb-4" key={key}>
            <div className="order-card skeleton-card">

              <div className="order-card-header skeleton-header">
                <div className="skeleton-box skeleton-id"></div>
                <div className="skeleton-box skeleton-status"></div>
              </div>

              <div className="order-card-body">
                <div className="skeleton-img"></div>

                <div className="order-details skeleton-details">
                  <div className="skeleton-line w-75"></div>
                  <div className="skeleton-line w-50"></div>
                  <div className="skeleton-line w-60"></div>
                  <div className="skeleton-line w-40"></div>
                </div>
              </div>

              <div className="order-card-footer">
                <div className="skeleton-line w-25"></div>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrackOrderSkeleton;
